export default {
  en: 'en',
  vi: 'vi',
  es: 'es',
  br: 'br',
  fr: 'fr',
  de: 'de',
  id: 'id',
  it: 'it',
  tr: 'tr',
  ja: 'ja',
  nl: 'nl',
  ru: 'ru',
  pl: 'pl',
  da: 'da',
  zh: 'zh',
  sl: 'sl',
  si: 'si',
  lv: 'lv',
}
